<template>
  <div class="column is-3-desktop is-4-tablet is-12-mobile">
    <div class="columns is-vcentered is-mobile is-variable is-2">
      <div class="column is-narrow">
        <album-cover
          v-bind:album="this.album"
          v-bind:isSmall="true"
          v-on:click="togglePlay"
          class="album-cover is-64x64 poly-cursor-pointer"
        >
          <span v-if="isPlaying" class="state-icon icon is-medium has-text-black is-overlay poly-hidden poly-visible-touch">
            <i class="mdi mdi-pause"></i>
          </span>
          <span v-else class="state-icon icon is-medium has-text-black is-overlay poly-hidden poly-visible-touch">
            <i class="mdi mdi-play"></i>
          </span>
        </album-cover>
      </div>

      <div class="column poly-truncate">
        <dl>
          <dd class="album-name has-text-weight-bold poly-truncate">
            <router-link v-bind:to="{ name: 'album', params: { id: album.id } }">
              {{ album.name }}
            </router-link>
          </dd>
          <dd class="has-text-grey-light has-text-weight-semibold">
            <ul class="album-artists poly-truncate">
              <li
                v-for="(artist, index) in album.artists"
                v-bind:key="artist.id"
              >
                <span v-if="index > 0">, </span>
                <router-link v-bind:to="{ name: 'artist', params: { id: artist.id } }" class="has-text-grey-light">{{ artist.name }}</router-link>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
  import AlbumCover from '@/components/AlbumCover'

  export default {
    name: 'SearchTrackListItem',
    components: {
      AlbumCover
    },
    props: {
      album: {
        type: Object,
        required: true
      }
    },
    computed: {
      isPlaying: function () {
        return(
          this.$store.getters.isPlaying &&
          this.$store.getters.currentAlbum &&
          this.$store.getters.currentAlbum.id === this.album.id
        )
      },
      isPaused: function () {
        return(
          this.$store.getters.isPaused &&
          this.$store.getters.currentAlbum &&
          this.$store.getters.currentAlbum.id === this.album.id
        )
      },
      isStopped: function () {
        return(
          this.$store.getters.isStopped ||
          (
            this.$store.getters.currentAlbum &&
            this.$store.getters.currentAlbum.id !== this.album.id
          )
        )
      }
    },
    methods: {
      togglePlay: function () {
        if (this.isStopped) {
          this.fetchAlbumTracks().then((response) =>
            this.$store.commit('playTracks', { tracks: response.data.tracks })
          ).catch(() =>
            console.error(`There was an error trying to get tracks for album with id ${this.album.id}`)
          )
        } else {
          this.$store.commit('togglePlay')
        }
      },
      fetchAlbumTracks: function () {
        return this.$apollo.query({
          query: require('@/graphql/AlbumTracks.gql'),
          variables: { albumId: this.album.id }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "~bulma/sass/utilities/initial-variables";

  .album-cover .state-icon {
    margin: auto;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 100%;
    border: 1px solid $white-ter;
  }
  .album-cover:hover .state-icon { visibility: visible; }
  .album-artists li { display: inline; }
  .album-artists {
    font-size: 0.85rem;
    margin-top: -0.16rem;
  }

  // Mobile specific modifiers
  @media (max-width: $tablet - 1) {
    .album-name { font-size: 0.9rem; }
    .album-cover .state-icon { transform: scale(1.0); }
  }
</style>
